import { render, staticRenderFns } from "./SearchMidwife.vue?vue&type=template&id=4922a3be"
import script from "./SearchMidwife.vue?vue&type=script&lang=js"
export * from "./SearchMidwife.vue?vue&type=script&lang=js"
import style0 from "./SearchMidwife.vue?vue&type=style&index=0&id=4922a3be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports